<template>
  <v-main>
    <div class="option-input">
      <v-row no-gutters align="center">
        <v-text-field v-model="option.op" :label="`Option ${index + 1}`" class="text-input" :error-messages="option.errorMessage"></v-text-field>
        <v-btn v-if="option.deletable" icon @click="removeSelfFromOptionsList">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-btn v-if="!option.imageEnabled" icon @click="option.imageEnabled = true">
          <v-icon>mdi-camera</v-icon>+
        </v-btn>
      </v-row>
      <v-row no-gutters v-if="option.imageEnabled" align="center">
        <v-file-input
          accept="image/*"
          label="Image (Optional)"
          @change="addImageToOption"
          prepend-icon="mdi-camera"
          class="image-input"
        ></v-file-input>
        <v-btn icon @click="option.imageEnabled = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-row>
    </div>
  </v-main>
</template>

<script>
import Helper from "@utils/misc";

export default {
  name: "OptionInput",
  methods: {
    removeSelfFromOptionsList() {
      this.$emit("removeSelfFromOptionsList", this.option);
    },
    // adds image to a option
    async addImageToOption(file) {
      if (file) {
        this.option.image = await Helper.toBase64(file);
      }
    }
  },
  data() {
    return {
      imageEnabled: false
    };
  },
  props: ["option", "index"]
};
</script>

<style scoped>
.text-input,
.image-input {
  color: #009688;
}
</style>